export const routerHistory = [
    {
        path: '/system/history',
        name: 'History',
        meta: {
            authRequired: true,
            roleDefault: 'all',
            role: [],
            typeRouterForm: false,
            titleJP: '管理ログ',
            pageNames: [
                {
                    text: 'ダッシュボード',
                    href: '/'
                },
                {
                    text: '管理ログ',
                    active: true
                }
            ]
        },
        component: () => import('@/views/pages/history')
    }
];
